<template>
    <b-modal centered ref="modal" title="Share Vehicle">
        <basic-info :show-view-button="false" :vehicle="vehicle"/>
        <br/>
        <form @submit.prevent="submit()">
            <b-form-group
                :invalid-feedback="form.invalidFeedback('name')"
                :state="form.state('name')"
                label="Name"
                label-for="name"
            >
                <b-form-input
                    :state="form.state('name')"
                    id="name"
                    v-model="form.name"
                />
            </b-form-group>
            <b-form-group
                :invalid-feedback="form.invalidFeedback('email')"
                :state="form.state('email')"
                label="Email"
                label-for="email"
            >
                <b-form-input
                    :state="form.state('email')"
                    id="email"
                    v-model="form.email"
                />
            </b-form-group>
        </form>
        <div slot="modal-footer">
            <b-button @click="$refs.modal.hide()">Cancel</b-button>
            <b-button @click="submit()" variant="primary"><i class="mdi mdi-send"></i> Send</b-button>
        </div>
    </b-modal>
</template>

<script>
    import BasicInfo from "@/components/main/vehicle/BasicInfo";
    import Share from "@/models/share";

    export default {
        props: {
            vehicle: {
                required: true,
                type: Object,
            }
        },
        components: {
            BasicInfo
        },
        data() {
            return {
                form: new Form(
                    {
                        name: null,
                        email: null,
                    },
                    {
                        name: 'required|string|max:255',
                        email: 'required|email|max:255'
                    }
                )
            }
        },
        methods: {
            submit() {
                this.form.validate()
                    .then(() => {
                        let share = new Share(this.form);
                        share
                            .custom(`/web-api/vehicle/${this.vehicle.id}/share`)
                            .save()
                            .then(response => {
                                this.$notify.success({
                                    message: `Vehicle has been sent to ${this.form.email}.`
                                });
                                this.$emit('success', response);
                            })
                    })
            },
            show() {
                this.$refs.modal.show();
                this.form.clearFields();
            },
            hide() {
                this.$refs.modal.hide();
            },
        }
    }
</script>

<style scoped>

</style>
